import { Injectable } from '@angular/core';
import { CiudadanosService } from '../services/ciudadanos/ciudadanos.service';
import { LopdCiudadanoModel, OpcionesAplicacionesModel } from '../services/ciudadanos/models/lopdCiudadano.model';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LopdManager {
  public lopdApps = new Subject<OpcionesAplicacionesModel[]>();

  public constructor(
    private ciudadanosService: CiudadanosService
  ) {}

  public async loadApps(): Promise<void> {
    const ciudadanos: LopdCiudadanoModel[] = await this.ciudadanosService.getLopdsListCiudadanos()
    this.lopdApps.next(ciudadanos[0]?.opcionesAplicaciones);
  }
}
